import { axiosInstance } from './apiCommon';

export interface LCASoftwareVersionModel {
  id: string;
  lcaSoftwareId: string;
  name: string;
}

export interface LCASoftwareModel {
  id: string;
  name: string;
  versionRequired: boolean;
  lcaSoftwareVersions: LCASoftwareVersionModel[];
}

export interface LCASoftwareCreateModel {
  id?: string;
  name: string;
  versionRequired: boolean;
}

export interface LCASoftwareVersionCreateModel {
  id?: string;
  name: string;
}

const BASE = '/api/admin/v1/AdminLCASoftware';

export const getLCASoftwareAll = async (): Promise<LCASoftwareModel[]> => {
  return (await axiosInstance.get<LCASoftwareModel[]>(BASE)).data;
};

export const createLCASoftware = async (data: LCASoftwareCreateModel): Promise<LCASoftwareModel> => {
  return (await axiosInstance.post<LCASoftwareModel>(BASE, data)).data;
};

export const updateLCASoftware = async (id: string, data: LCASoftwareCreateModel): Promise<void> => {
  await axiosInstance.put(`${BASE}/${id}`, data);
};

export const deleteLCASoftware = async (id: string): Promise<void> => {
  await axiosInstance.delete(`${BASE}/${id}`);
};

export const createLCASoftwareVersion = async (
  softwareId: string,
  data: LCASoftwareVersionCreateModel
): Promise<LCASoftwareVersionModel> => {
  return (await axiosInstance.post<LCASoftwareVersionModel>(`${BASE}/${softwareId}/versions`, data)).data;
};

export const updateLCASoftwareVersion = async (
  softwareId: string,
  versionId: string,
  data: LCASoftwareVersionCreateModel
): Promise<void> => {
  await axiosInstance.put(`${BASE}/${softwareId}/versions/${versionId}`, data);
};

export const deleteLCASoftwareVersion = async (softwareId: string, versionId: string): Promise<void> => {
  await axiosInstance.delete(`${BASE}/${softwareId}/versions/${versionId}`);
};
